var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-8 w-full h-full bg-white"},[_c('Images')],1)}
var staticRenderFns = []

export { render, staticRenderFns }